export const colorNeutral = "#000000";
export const distance100AOffsetX = "0px";
export const distance100AOffsetY = "0.4px";
export const distance100ABlurRadius = "0.5px";
export const distance100ASpreadRadius = "0px";
export const distance100AColor = "rgba(0,0,0,0.25)";
export const distance100BOffsetX = "0px";
export const distance100BOffsetY = "0.6px";
export const distance100BBlurRadius = "0.7px";
export const distance100BSpreadRadius = "-1.2px";
export const distance100BColor = "rgba(0,0,0,0.25)";
export const distance100COffsetX = "0px";
export const distance100COffsetY = "1.4px";
export const distance100CBlurRadius = "1.6px";
export const distance100CSpreadRadius = "-2.5px";
export const distance100CColor = "rgba(0,0,0,0.25)";
export const distance100DOffsetX = "0px";
export const distance100DOffsetY = "0px";
export const distance100DBlurRadius = "2.8px";
export const distance100DSpreadRadius = "-1.2px";
export const distance100DColor = "rgba(0,0,0,0.2)";
export const distance200AOffsetX = "0px";
export const distance200AOffsetY = "0.1px";
export const distance200ABlurRadius = "0.1px";
export const distance200ASpreadRadius = "0px";
export const distance200AColor = "rgba(0,0,0,0.25)";
export const distance200BOffsetX = "0px";
export const distance200BOffsetY = "0.4px";
export const distance200BBlurRadius = "0.5px";
export const distance200BSpreadRadius = "-0.7px";
export const distance200BColor = "rgba(0,0,0,0.25)";
export const distance200COffsetX = "0px";
export const distance200COffsetY = "1.1px";
export const distance200CBlurRadius = "1.2px";
export const distance200CSpreadRadius = "-1.5px";
export const distance200CColor = "rgba(0,0,0,0.25)";
export const distance200DOffsetX = "0px";
export const distance200DOffsetY = "2.7px";
export const distance200DBlurRadius = "3.2px";
export const distance200DSpreadRadius = "-2px";
export const distance200DColor = "rgba(0,0,0,0.25)";
export const distance200EOffsetX = "0px";
export const distance200EOffsetY = "-0.1px";
export const distance200EBlurRadius = "1.2px";
export const distance200ESpreadRadius = "0px";
export const distance200EColor = "rgba(0,0,0,0.1)";
export const distance200FOffsetX = "0px";
export const distance200FOffsetY = "0px";
export const distance200FBlurRadius = "3.5px";
export const distance200FSpreadRadius = "-2.2px";
export const distance200FColor = "rgba(0,0,0,0.2)";
export const distance300AOffsetX = "0px";
export const distance300AOffsetY = "0.4px";
export const distance300ABlurRadius = "0.5px";
export const distance300ASpreadRadius = "0px";
export const distance300AColor = "rgba(0,0,0,0.07)";
export const distance300BOffsetX = "0px";
export const distance300BOffsetY = "1.2px";
export const distance300BBlurRadius = "1.3px";
export const distance300BSpreadRadius = "-0.8px";
export const distance300BColor = "rgba(0,0,0,0.07)";
export const distance300COffsetX = "0px";
export const distance300COffsetY = "2.9px";
export const distance300CBlurRadius = "3.3px";
export const distance300CSpreadRadius = "-1.7px";
export const distance300CColor = "rgba(0,0,0,0.07)";
export const distance300DOffsetX = "0.1px";
export const distance300DOffsetY = "6.9px";
export const distance300DBlurRadius = "7.8px";
export const distance300DSpreadRadius = "-2.5px";
export const distance300DColor = "rgba(0,0,0,0.07)";
export const distance300EOffsetX = "0px";
export const distance300EOffsetY = "0px";
export const distance300EBlurRadius = "7.8px";
export const distance300ESpreadRadius = "-2.5px";
export const distance300EColor = "rgba(0,0,0,0.1)";
export const distance400AOffsetX = "0px";
export const distance400AOffsetY = "0.4px";
export const distance400ABlurRadius = "0.5px";
export const distance400ASpreadRadius = "0px";
export const distance400AColor = "rgba(0,0,0,0.05)";
export const distance400BOffsetX = "0px";
export const distance400BOffsetY = "1.8px";
export const distance400BBlurRadius = "2px";
export const distance400BSpreadRadius = "-0.4px";
export const distance400BColor = "rgba(0,0,0,0.05)";
export const distance400COffsetX = "0px";
export const distance400COffsetY = "3.3px";
export const distance400CBlurRadius = "3.7px";
export const distance400CSpreadRadius = "-0.7px";
export const distance400CColor = "rgba(0,0,0,0.05)";
export const distance400DOffsetX = "0.1px";
export const distance400DOffsetY = "5.3px";
export const distance400DBlurRadius = "6px";
export const distance400DSpreadRadius = "-1.1px";
export const distance400DColor = "rgba(0,0,0,0.05)";
export const distance400EOffsetX = "0.1px";
export const distance400EOffsetY = "8.4px";
export const distance400EBlurRadius = "9.5px";
export const distance400ESpreadRadius = "-1.4px";
export const distance400EColor = "rgba(0,0,0,0.05)";
export const distance400FOffsetX = "0.1px";
export const distance400FOffsetY = "13.1px";
export const distance400FBlurRadius = "14.7px";
export const distance400FSpreadRadius = "-1.8px";
export const distance400FColor = "rgba(0,0,0,0.05)";
export const distance400GOffsetX = "0.2px";
export const distance400GOffsetY = "19.9px";
export const distance400GBlurRadius = "22.4px";
export const distance400GSpreadRadius = "-2.1px";
export const distance400GColor = "rgba(0,0,0,0.05)";
export const distance400HOffsetX = "0.3px";
export const distance400HOffsetY = "29.3px";
export const distance400HBlurRadius = "33px";
export const distance400HSpreadRadius = "-2.5px";
export const distance400HColor = "rgba(0,0,0,0.05)";
export const distance400IOffsetX = "0px";
export const distance400IOffsetY = "0px";
export const distance400IBlurRadius = "9.5px";
export const distance400ISpreadRadius = "-1.4px";
export const distance400IColor = "rgba(0,0,0,0.075)";
export const inset100AOffsetX = "0px";
export const inset100AOffsetY = "0.4px";
export const inset100ABlurRadius = "0.5px";
export const inset100ASpreadRadius = "0px";
export const inset100AColor = "rgba(0,0,0,0.0833)";
export const inset100BOffsetX = "0px";
export const inset100BOffsetY = "0.6px";
export const inset100BBlurRadius = "0.7px";
export const inset100BSpreadRadius = "-1.2px";
export const inset100BColor = "rgba(0,0,0,0.0833)";
export const inset100COffsetX = "0px";
export const inset100COffsetY = "1.4px";
export const inset100CBlurRadius = "1.6px";
export const inset100CSpreadRadius = "-2.5px";
export const inset100CColor = "rgba(0,0,0,0.0833)";
export const inset100DOffsetX = "0px";
export const inset100DOffsetY = "0px";
export const inset100DBlurRadius = "2.8px";
export const inset100DSpreadRadius = "-1.2px";
export const inset100DColor = "rgba(0,0,0,0.0667)";
export const inset200AOffsetX = "0px";
export const inset200AOffsetY = "0.1px";
export const inset200ABlurRadius = "0.1px";
export const inset200ASpreadRadius = "0px";
export const inset200AColor = "rgba(0,0,0,0.0833)";
export const inset200BOffsetX = "0px";
export const inset200BOffsetY = "0.4px";
export const inset200BBlurRadius = "0.5px";
export const inset200BSpreadRadius = "-0.7px";
export const inset200BColor = "rgba(0,0,0,0.0833)";
export const inset200COffsetX = "0px";
export const inset200COffsetY = "1.1px";
export const inset200CBlurRadius = "1.2px";
export const inset200CSpreadRadius = "-1.5px";
export const inset200CColor = "rgba(0,0,0,0.0833)";
export const inset200DOffsetX = "0px";
export const inset200DOffsetY = "2.7px";
export const inset200DBlurRadius = "3.2px";
export const inset200DSpreadRadius = "-2px";
export const inset200DColor = "rgba(0,0,0,0.0833)";
export const inset200EOffsetX = "0px";
export const inset200EOffsetY = "-0.1px";
export const inset200EBlurRadius = "1.2px";
export const inset200ESpreadRadius = "0px";
export const inset200EColor = "rgba(0,0,0,0.0333)";
export const inset200FOffsetX = "0px";
export const inset200FOffsetY = "0px";
export const inset200FBlurRadius = "3.5px";
export const inset200FSpreadRadius = "-2.2px";
export const inset200FColor = "rgba(0,0,0,0.0667)";
export const ringOffsetX = "0px";
export const ringOffsetY = "0px";
export const ringBlurRadius = "0px";
export const ringSpreadRadius = "2px";
export const haloOffsetX = "0px";
export const haloOffsetY = "0px";
export const haloBlurRadius = "0px";
export const haloSpreadRadius = "3px";